import DonutChart from "../../components/DonutChart";
import { Shades } from "../../utils/common";
import { MetricCard, CardHeader } from "./Common";
import MuiCallsTable from "./MuiCallsTable";

const sumTotalCalls = (arr = []) => arr.reduce((sum, d) => sum + d.total_calls, 0);

export default function CallSection({
  sectionTitle,
  durationTitle,
  avgDurationTitle,
  attendeeChartTitle,
  attendeeLabelKey,
  statusChartTitle,
  tableTitle,
  data,
  columns,
  pagination, // { page, limit, total } — page is 1-indexed
  onPaginationModelChange, // (model: {page, pageSize} - 0-indexed) => void
  tableLoadingKey,
  tableLoading,
  chartLoading,
  formatDuration,
  exportFileName,
}) {
  return (
    <div className="bg-gray-50 border border-gray-100 rounded-xl shadow-sm my-4 mx-auto max-w-[1600px] p-1 sm:p-4">
      <p className="text-xl font-semibold text-gray-700 text-left mb-4">{sectionTitle}</p>

      <div className="grid gap-4 grid-cols-1 mb-4">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          <div className="grid grid-cols-1 gap-4">
            <MetricCard title={durationTitle} value={formatDuration(data.total_duration)} />
            <MetricCard title={avgDurationTitle} value={formatDuration(data.avg_duration)} />
          </div>

          <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 flex flex-col md:col-span-2">
            <CardHeader title={attendeeChartTitle} />
            <DonutChart data={data.calls_by_attendee?.map((d) => d.total_calls).slice(0, 5)} labels={data.calls_by_attendee?.map((d) => d[attendeeLabelKey]).slice(0, 5)} rounded={true} centerValue={sumTotalCalls(data.calls_by_attendee)} centerLabel={false} donutWidth={17} colors={Shades.sky} height="180px" width="180px" loading={chartLoading} />
          </div>

          <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 flex flex-col md:col-span-2">
            <CardHeader title={statusChartTitle} />
            <DonutChart data={data.calls_by_status?.map((d) => d.total_calls).slice(0, 5)} labels={data.calls_by_status?.map((d) => d.status).slice(0, 5)} rounded={true} centerValue={sumTotalCalls(data.calls_by_status)} centerLabel={false} donutWidth={17} colors={Shades.sky} height="180px" width="180px" loading={chartLoading} />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 flex flex-col">
        <CardHeader title={tableTitle} />
        <MuiCallsTable rows={data.calls} columns={columns} loading={!!tableLoading[tableLoadingKey]} rowCount={pagination.total} paginationModel={{ page: Math.max(0, (pagination.page || 1) - 1), pageSize: pagination.limit }} onPaginationModelChange={onPaginationModelChange} title={tableTitle} fileName={exportFileName} />
      </div>
    </div>
  );
}
